import {client as http, axiosInstance} from "@/http_client";

export default {
    state: {
        currentUser: (localStorage.getItem('user') != null) ? JSON.parse(localStorage.getItem('user')) : null,
        token: (localStorage.getItem('token') != null) ? localStorage.getItem('token') : null,
        // Profile verification prompt state, shared between the global modal
        // and the dashboard reminder banner. `requested` is set when the user
        // clicks the banner to summon the modal.
        profilePrompt: {pending: false, due: false, requested: false}
    },
    getters: {
        currentUser: state => state.currentUser,
        token: state => state.token,
        profilePrompt: state => state.profilePrompt
    },
    mutations: {
        setUser(state, payload) {
            state.currentUser = payload;
            state.token = payload.token;
        },
        setLogout(state) {
            state.currentUser = null;
            state.token = null;
        },
        setProfilePromptStatus(state, {pending, due}) {
            state.profilePrompt = {...state.profilePrompt, pending, due};
        },
        setProfilePromptRequested(state, requested) {
            state.profilePrompt = {...state.profilePrompt, requested};
        }
    },
    actions: {
        login({commit}, payload) {
            return new Promise((resolve, reject) => {
                http.post('/auth/', payload).then(response => {
                    response.data.user.token = response.data.token;
                    localStorage.setItem('token', response.data.token);
                    localStorage.setItem('user', JSON.stringify(response.data.user));

                    console.log('Setting token from login.');
                    axiosInstance.defaults.headers.common['Authorization'] = response.data.token;

                    commit('setUser', response.data.user);
                    resolve(response.data);
                }, err => {
                    localStorage.removeItem('token');
                    reject(err.response.data);
                });
            });
        },
        makeLoginCheck({}, payload) {
            return new Promise((resolve, reject) => {
                http.post('app/users/login', payload).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log('err', err);
                    reject(err.response);
                });
            });
        },
        makeLoginRequest({}, payload) {
            return new Promise((resolve, reject) => {
                http.post('app/users/request', payload).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log('err', err);
                    reject(err.response);
                });
            });
        },
        makeLoginAccess({commit}, payload) {
            return new Promise((resolve, reject) => {
                http.post('app/users/access', payload).then(response => {
                    response.data.user.token = response.data.token;
                    localStorage.setItem('token', response.data.token);
                    localStorage.setItem('user', JSON.stringify(response.data.user));

                    console.log('Setting token from login.');
                    axiosInstance.defaults.headers.common['Authorization'] = response.data.token;

                    commit('setUser', response.data.user);
                    resolve(response.data);
                }, err => {
                    localStorage.removeItem('token');
                    reject(err.response.data);
                });
            });
        },
        signOut({commit}) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            commit('setLogout');
        },
        loginRelay({commit}, payload) {
            console.log('Login relay', payload);
            // Never persist a missing token: setItem() stringifies it to
            // "undefined", which is truthy on the next boot and gets sent as
            // the Authorization header, 401-ing every call.
            if (!payload.token) {
                throw new Error('Login relay called without a token.');
            }
            localStorage.setItem('token', payload.token);
            localStorage.setItem('user', JSON.stringify(payload));
            commit('setUser', payload);
        }
    }
};
